import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";

interface Props {
  onClick: () => void;
  displayText: string;
}

export const BackButtonWithinForm = ({ onClick, displayText }: Props) => {
  return (
    <div role="button" onClick={() => onClick()} tabIndex={0} onKeyDown={() => {}}>
      <Flex
        style={{ marginTop: "16px", marginBottom: "16px" }}
        alignItems="center"
        justifyContent="flex-start"
        gap={4}
      >
        <Icon
          type="arrow-left"
          className="inline-md"
          color={Colors.Neutral600}
          variant="outline"
          size="large"
        />
        <Text variant="secondary-md">{displayText}</Text>
      </Flex>
    </div>
  );
};
